import(/* webpackMode: "eager" */ "/home/ubuntu/apps/icomm/dev/icomm/app/(dashboard)/templates/page.tsx");
